// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"player-module--player-wrapper--2xI-d","player":"player-module--player--1fhpq","playIcon":"player-module--play-icon--2_8nF"};